import {useEffect} from "react";
import {useMap} from "@vis.gl/react-google-maps";

const CftvMapCameraFocus = ({camera}) => {
    const map = useMap();

    useEffect(() => {
        const latitude = Number(camera?.latitude ?? camera?.lat);
        const longitude = Number(camera?.longitude ?? camera?.lng);

        if (!map || !Number.isFinite(latitude) || !Number.isFinite(longitude)) return;

        map.panTo({lat: latitude, lng: longitude});
        map.setZoom(18);
    }, [camera, map]);

    return null;
};

export default CftvMapCameraFocus;
